import request from '@/utils/request'

export function getFirebaseNotificationRequests(params) {
  return request({
    url: '/Event/firebase-notification-requests',
    method: 'get',
    params,
  })
}

export function getErrorEvents(params) {
  return request({
    url: '/Event/error-events',
    method: 'get',
    params,
  })
}
